import { BookingAddressType } from 'generated/graphql'
import { ConsignmentPair } from 'hooks/booking/useBookingAddresses'
import { AddressEta } from 'hooks/useAllAddressesEta'

import { CompletedTrackingSection } from './CompletedTrackingSection'
import { TrackingInfoSection } from './TrackingInfoSection'

interface TrackingSectionContentProps {
  isCompleted: boolean
  bookingData: any
  bookingCurrentAction: any
  nextBookingAction: any
  consignmentPairs?: ConsignmentPair[]
  collectionCompletedAt?: string
  deliveryCompletedAt?: string
  isMobile?: boolean
  nextAddressEta?: string | null
  etaWindowMinutes?: number | null
  stopName?: string | null
  stopAddress?: string | null
  etaLoading?: boolean
  onDetailsClick: () => void
  onProofOfDeliveryClick?: () => void
  onProofOfCollectionClick?: () => void
  onCombinedDocsClick?: () => void
  referenceAddressType?: BookingAddressType | null
  collectionAttachmentCount?: number
  deliveryAttachmentCount?: number
  combinedDocAttachmentCount?: number
  addressEtas?: AddressEta[]
  talkToAnExpertUrl: string
}

export const TrackingSectionContent = ({
  isCompleted,
  bookingData,
  bookingCurrentAction,
  nextBookingAction,
  consignmentPairs,
  collectionCompletedAt,
  deliveryCompletedAt,
  isMobile,
  nextAddressEta,
  etaWindowMinutes,
  stopName,
  stopAddress,
  etaLoading,
  onDetailsClick,
  onProofOfDeliveryClick,
  onProofOfCollectionClick,
  onCombinedDocsClick,
  referenceAddressType,
  collectionAttachmentCount,
  deliveryAttachmentCount,
  combinedDocAttachmentCount,
  addressEtas,
  talkToAnExpertUrl,
}: TrackingSectionContentProps) => {
  return isCompleted ? (
    <CompletedTrackingSection
      booking={bookingData}
      talkToAnExpertUrl={talkToAnExpertUrl}
      bookingCurrentAction={bookingCurrentAction}
      nextBookingAction={nextBookingAction}
      collectionTime={collectionCompletedAt}
      deliveryTime={deliveryCompletedAt}
      onDetailsClick={onDetailsClick}
      onProofOfDeliveryClick={onProofOfDeliveryClick}
      onProofOfCollectionClick={onProofOfCollectionClick}
      onCombinedDocsClick={onCombinedDocsClick}
      referenceAddressType={referenceAddressType}
      collectionAttachmentCount={collectionAttachmentCount}
      deliveryAttachmentCount={deliveryAttachmentCount}
      combinedDocAttachmentCount={combinedDocAttachmentCount}
    />
  ) : (
    <TrackingInfoSection
      onDetailsClick={onDetailsClick}
      isMobile={isMobile}
      booking={bookingData}
      talkToAnExpertUrl={talkToAnExpertUrl}
      bookingCurrentAction={bookingCurrentAction}
      nextBookingAction={nextBookingAction}
      consignmentPairs={consignmentPairs}
      nextAddressEta={nextAddressEta}
      etaWindowMinutes={etaWindowMinutes}
      stopName={stopName}
      stopAddress={stopAddress}
      etaLoading={etaLoading}
      onProofOfDeliveryClick={onProofOfDeliveryClick}
      onProofOfCollectionClick={onProofOfCollectionClick}
      referenceAddressType={referenceAddressType}
      collectionAttachmentCount={collectionAttachmentCount}
      deliveryAttachmentCount={deliveryAttachmentCount}
      addressEtas={addressEtas}
    />
  )
}
